import { createContext, useContext } from 'react';

export const GlobalModulesContext = createContext(null);

export function GlobalModulesProvider({ children, globalModules }) {
  return (
    <GlobalModulesContext.Provider value={globalModules}>{children}</GlobalModulesContext.Provider>
  );
}

export function useGlobalModules() {
  const context = useContext(GlobalModulesContext);
  if (context === undefined) {
    throw new Error('useGlobalModules must be used within a GlobalModulesProvider');
  }
  return context;
}

// Optional: Helper hooks for specific global module parts
export function useTranslations() {
  const globalModules = useGlobalModules();
  return globalModules.translations;
}

export function useNavigation() {
  const globalModules = useGlobalModules();
  return globalModules.navigation;
}
